import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { getSpacing } from '../../const/spacing';
import { Text } from '../Text/Text';
const StyledList = styled('ul', {
    margin: 0,
    paddingLeft: getSpacing('2'),
});
const StyledListItem = styled('li', {
    marginBottom: getSpacing('1/2'),
    ':last-child': {
        marginBottom: 0,
    },
});
export const BulletList = ({ items }) => {
    return (_jsx(StyledList, { children: items.map(({ key, text, itemTextProps }) => (_jsx(StyledListItem, { children: _jsx(Text, { ...itemTextProps, children: text }) }, key))) }));
};
